import * as Yup from 'yup';
import configBuilder from '../config-builder';
import catchApiFailure from '../catch-api-error';
import ApiFactory from '../../index';
import { normalizeJsonToApi } from '../../helpers';

const api = ApiFactory.getApi();

export const Schema = Yup.object().shape({
  postId: Yup.string().required(),
  date: Yup.string().matches(/^(\d{4}-\d{2}-\d{2})$/).required(),
  location: Yup.string().required(),
});

export const isValid = async (params) => await Schema.isValid(params);
export const validate = async (params) => Schema.validate(params);
export const getBody = (params) => {
  const req = Schema.cast(params);
  return normalizeJsonToApi({ date: req.date, location: req.location });
};
export const url = ({ postId }) => `/v1/posts/${postId}`;
export const execute = async (params) => api.put(
  url(params),
  getBody(params),
  configBuilder(params)
).catch(catchApiFailure);